export default "__VITE_ASSET__BD96QrxF__"